import { endpoint } from '@/services/api/endpoint';

import { DocumentApproveBodySchema, DocumentRejectBodySchema } from '@/domain/approvals/schemas';
import { DocumentEntitySchema } from '@/domain/documents/schemas';

export const approvalsApi = {
  // The current approver approves the document; the response is the updated document.
  approveDocument: endpoint({
    method: 'POST',
    url: 'approvals/document/sign',
    body: DocumentApproveBodySchema,
    response: DocumentEntitySchema,
  }),
  // The current approver rejects the document; the response is the updated document.
  rejectDocument: endpoint({
    method: 'POST',
    url: 'approvals/document/reject',
    body: DocumentRejectBodySchema,
    response: DocumentEntitySchema,
  }),
};
